export type EqualityFn<T> = (a: T, b: T) => boolean;
export function strictEquality<T>(a: T, b: T) {
    return a === b;
}

export function JSONEquality<T>(a: T, b: T) {
    return JSON.stringify(a) === JSON.stringify(b);
}

export function ArrayEquality<T>(a: T[], b: T[], comparer: EqualityFn<T> = strictEquality)
{
    if (a == b)
        return true;
    if (!a || !b)
        return false;
    
    for (let i = 0; i < Math.max(a.length, b.length); i++)
    {
        if (!comparer(a[i], b[i]))
            return false;
    }
    return true;
}